import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">移动客户端</h2>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-lg border border-background-200/70 p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-lg md:text-xl font-bold text-foreground-900 font-heading mb-3">{appContent.title}</h3>
            <p className="text-sm text-foreground-600 mb-6">{appContent.subtitle}</p>
            <div className="grid grid-cols-2 gap-2 mb-6">
              {appContent.features.map((f) => (
                <div key={f} className="flex items-center gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-sm flex-shrink-0"></i>
                  <span>{f}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <div className="px-5 py-2.5 bg-foreground-950 text-background-50 rounded-md text-sm font-semibold flex items-center gap-2 cursor-pointer whitespace-nowrap">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </div>
              <div className="px-5 py-2.5 bg-foreground-950 text-background-50 rounded-md text-sm font-semibold flex items-center gap-2 cursor-pointer whitespace-nowrap">
                <i className="ri-android-fill text-lg"></i>
                安卓版下载
              </div>
            </div>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative w-[200px] h-[200px] md:w-[240px] md:h-[240px] bg-background-100 rounded-lg flex items-center justify-center border border-background-200/60">
              <div className="text-center">
                <div className="w-24 h-24 md:w-28 md:h-28 mx-auto bg-background-50 rounded-md border-2 border-foreground-800 flex items-center justify-center">
                  <span className="text-lg md:text-xl font-black text-primary-500 font-heading">51</span>
                </div>
                <p className="mt-3 text-xs text-foreground-500">扫码下载客户端</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}